export const ACCESS_LEVEL_ANY = "AccessLevel::Any";
export const ACCESS_LEVEL_GUEST = "AccessLevel::Guest";
export const ACCESS_LEVEL_AUTH = "AccessLevel::Auth";
